import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect'
import connectedAuthWrapper from 'redux-auth-wrapper/connectedAuthWrapper'

// import Loading from './components/Loading'

// const locationHelper = locationHelperBuilder({})


//Actual Content
// var session_token = localStorage.getItem('jwt');

export const userIsTenantEmployeeRedir = connectedRouterRedirect({
  redirectPath: '/facilitylogin',
  allowRedirectBack: false,
  authenticatedSelector: state => state.authService != null && state.authService.loggedIn === true && state.authService.token !== null  && state.authService.user_type === "tenant_employee" ,
 // predicate: user => user.isAdmin,
  wrapperDisplayName: 'UserIsTeanantEmployee'
})




export const userIsPropertyManagerRedir = connectedRouterRedirect({
  redirectPath: (state => state.authService !== null && state.authService.IsOnPremise) ? '/GlobalError' : '/ensemblelogin',
  allowRedirectBack: false,
  authenticatedSelector: state => state.authService !== null && state.authService.loggedIn === true && state.authService.token !== null  && state.authService.user_type === "property_manager", 
  wrapperDisplayName: 'UserIsTeanantEmployee'
})



const userIsAuthenticatedDefaults = {
  authenticatedSelector:  state => state.authService.loggedIn === true && state.authService.token !== null  && state.authService.user_type !== null,
  wrapperDisplayName: 'UserIsAuthenticated'
}

export const userIsAuthenticated = connectedAuthWrapper(userIsAuthenticatedDefaults)

export const userIsAuthenticatedRedir = connectedRouterRedirect({
  ...userIsAuthenticatedDefaults,
  redirectPath: '/facilitylogin'
})


export const userIsAdminRedir = connectedRouterRedirect({
  redirectPath: '/',
  allowRedirectBack: false,
  authenticatedSelector: state => state.user.data !== null && state.user.data.isAdmin,
  predicate: user => user.isAdmin,
  wrapperDisplayName: 'UserIsAdmin'
})





// Not Authenticated or pre login content

// const userIsNotAuthenticatedDefaults = {
//   // Want to redirect the user when they are done loading and authenticated
//   authenticatedSelector: state => state.authService.loggedIn === false && state.authService.token === null  && state.authService.user_type === null,
//   wrapperDisplayName: 'UserIsNotAuthenticated'
// }

// export const userIsNotAuthenticated = connectedAuthWrapper(userIsNotAuthenticatedDefaults)

// export const userIsNotAuthenticatedRedir = connectedRouterRedirect({
//   ...userIsNotAuthenticatedDefaults,
//   redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || '/',
//  // redirectPath: (state, ownProps) => '/',
//   allowRedirectBack: false
// })

